import { parseAnswerLine } from '~utils/answer-format'
import { sanitizeLineBreaks } from '~utils/string'

type FormattedAnswerTextProps = Readonly<{ text: string }>

// 수의사 답변 전용. 줄바꿈은 SanitizedText 와 같고, 굵게·불릿만 표시한다 (DRT-7109).
const FormattedAnswerText = ({ text }: FormattedAnswerTextProps) => {
  return (
    <>
      {sanitizeLineBreaks(text)
        .split('\n')
        .map((line, index) => {
          const { bullet, segments } = parseAnswerLine(line)
          return (
            <span key={index} className="break-words">
              {bullet && '• '}
              {segments.map((segment, segmentIndex) =>
                segment.bold ? (
                  <strong key={segmentIndex}>{segment.text}</strong>
                ) : (
                  <span key={segmentIndex}>{segment.text}</span>
                )
              )}
              <br />
            </span>
          )
        })}
    </>
  )
}

export default FormattedAnswerText
